module.exports = require("@finance/sui/lib/directives/prevent-scroll");